<button
  class="u-button"
  [ngClass]="buttonClass"
  (click)="fireEventClick($event)"
  [type]="type"
>
  <i *ngIf="icon !== ''" class="fas" [ngClass]="icon"></i>
  {{ text }}
</button>
